import { IFilterPaymentMethods } from './types';

export const filterPaymentMethods = ({ paymentMethods }: IFilterPaymentMethods) => paymentMethods;
